<template>
  <!-- <section class="content"> -->
  <div>
    <!-- <Toast style="margin-top: 35px" /> -->
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <!-- <div class="p-grid">
        <div class="p-col">
          <Button class="p-button-raised p-mr-2" style="float:right;" @click.prevent="openBasic"
                  icon="pi pi-plus"/>
        </div>
      </div> -->
      <div class="p-grid">
        <div class="p-col">
          <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
        </div>
      </div>
      <Dialog header="Employee" :visible.sync="displayBasic" @show="checkNepaliDateOrEnglish"
              :style="{width: '60vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'auto'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-4">
            <label for="employeeId">Employee Id<span style="color:red"></span></label>
            <InputText v-model.trim="employeeId" id="employeeId"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="employeeName">Employee Name<span style="color:red">*</span></label>
            <InputText v-model.trim="employeeName" id="employeeName"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="address">Address</label>
            <InputText v-model="address" id="address"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="panNo">PAN Number</label>
            <InputText v-model="panNo" id="panNo"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="pfNumber">PF Number</label>
            <InputText v-model="pfNumber" id="pfNumber"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="cifNo">Cif Number</label>
            <InputText v-model="cifNo" id="cifNo"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="bankAccountNumber">Bank Account No</label>
            <InputText v-model="bankAccountNumber" id="bankAccountNumber"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="contactNumber">Contact Number</label>
            <InputText v-model="contactNumber" id="contactNumber"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="">Salary Status</label>
            <div class="p-field p-col-12 p-md-6">
              <RadioButton id="active" name="Active" value="ACTIVE" v-model="salaryStatus"/>
              <label for="active">Active</label>
              <RadioButton id="inactive" name="Inactive" value="INACTIVE" v-model="salaryStatus"/>
              <label for="inactive">InActive</label>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Join Date</label>
            <date-picker v-model="dateOfJoin" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar"
                       id="dateOfJoin" v-model="dateOfJoin"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Group</label>
            <Dropdown v-model="employeeGroupId" :options="employeeGroupLists" optionLabel="value"
                      placeholder="Select Employee Group"
                      :filter="true"
                      :showClear="true" id="employeeGroup"/>
            <!--            {{employeeGroupId}}-->
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Sub Group</label>
            <Dropdown v-model="employeePositionId" :options="employeePositionLists" optionLabel="value"
                      placeholder="Select Employee Position"
                      :filter="true"
                      :showClear="true" id="employeePosition"/>
          </div>

           <div class="p-field p-col-12 p-md-4">
            <label>Sub Child Group</label>
            <Dropdown v-model="subGroupChildId" :options="employeePositionSubGroupLists" optionLabel="value"
                      placeholder="Select Sub Child Position"
                      :filter="true"
                      :showClear="true" id="subGroupChildId"/>
          </div>
          <!-- <div class="p-field p-col-12 p-md-4">
            <label for="payHead">Salary PayHead</label>
            <Dropdown v-model="payHeadId" optionLabel="name" :options="payGradeLists" placeholder="Select PayHead"
                      :filter="true"
                      :showClear="true" id="payHead"/>
          </div> -->
          <div class="p-field p-col-12 p-md-4">
            <label>Supervisor 1</label>
            <Dropdown v-model="supervisor1" optionLabel="name" :options="employeeDropdownList"
                      placeholder="Select Supervisor"
                      :filter="true"
                      :showClear="true" id="supervisor1"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Supervisor 2</label>
            <Dropdown v-model="supervisor2" optionLabel="name" :options="employeeDropdownList"
                      placeholder="Select Supervisor"
                      :filter="true"
                      :showClear="true" id="supervisor2"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Work Shift</label>
            <Dropdown v-model="workShift" optionLabel="name" :options="workShifts" placeholder="Work Shift"
                      :filter="true"
                      :showClear="true" id="workShift"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Cr Account Ledger</label>
            <Dropdown v-model="accountMasterId" optionLabel="name" :options="accountMasterList" placeholder="Select One"
                      :filter="true"

                      :showClear="true" id="account"/>
          </div>
          <DataTable v-if="!this.editing"
                     :value="payHeadList"
                     editMode="cell" class="editable-cells-table">
            <Column header="Pay Head" field="name"/>
            <Column header="Amount" field="amount">
              <template #body="slotProps">
                <InputText
                  v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2"
                  :maxFracionDigits="4"/>
              </template>
            </Column>
          </DataTable>
          <DataTable v-else
                     :value="payheadEditingList"
                     editMode="cell" class="editable-cells-table">
            <Column header="Pay Heads" field="name"/>
            <Column header="Amount" field="amount">
              <template #body="slotProps">
                <InputText
                  v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2"
                  :maxFracionDigits="4"/>
              </template>
            </Column>
          </DataTable>
        </div>

        <template #footer>
          <div v-if="!displayOnly" class="p-fluid p-formgrid p-grid">
            <div this class="p-field p-col-6 p-md-10">
              <Button class="p-button-raised" @click.prevent="addEmployee"
                      :label="!editing?'Add':'Update'"/>
              <Button class="p-button-raised p-button-info" v-if="!editing"
                      label="Add & New"/>
              <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
            </div>
          </div>
            <div v-if="displayOnly" class="p-fluid p-formgrid p-grid">
            <div this class="p-field p-col-6 p-md-10">
              <Button class="p-button-raised p-button-danger" @click.prevent="closeDialog" label="Close"/>
            </div>
          </div>
        </template>
      </Dialog>
    </form>
    <employeeList @edit-employee="editEmployee" @view-employee="viewEmployee"/>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import RadioButton from 'primevue/radiobutton'
import $ from 'jquery'
import InputMask from 'primevue/inputmask'
import employeeGroup from './employeeGroup.vue'
import Dropdown from 'primevue/dropdown'
import employeePosition from './employeePosition.vue'
import employeeList from './employeeList.vue'

export default {
  name: 'employee',
  data() {
    return {
      displayBasic: false,
      employeeName: '',
      openImageViewer: false,
      address: '',
      contactNumber: '',
      employeeId: '',
      panNo: '',
      pfNumber: '',
      cifNo: '',
      loading: false,
      editing: false,
      salaryStatus: 'ACTIVE',
      displayOnly: false,
      filters: {},
      payheadEditingList: [],
      hrPayHeadsDTOList: [],
      dateOfJoin: null,
      employeeGroup: {},
      employeePosition: {},
      englishDateEnabled: true,
      payHeadId: '',
      accountId: '',
      accountMasterId: null,
      supervisor1: '',
      supervisor2: '',
      workShift: null,
      supervisor1Id: 0,
      supervisor2Id: 0,
      accountCrId: 0,
      employeePositionId: '',
      subGroupChildId: '',
      subGroupChId: 0,
      employeeGroupId: '',
      bankAccountNumber: '',
      showItemUploadDialog: false
    }
  },
  computed: {
    employeeGroupLists() {
      return this.$store.state.hr.employeeGroupListsDropdown
    },
    payHeadList() {
      return this.$store.state.hr.payHeadList
    },
    employeePositionLists() {
      return this.$store.state.hr.employeePositionListsDropdown
    },
    employeePositionSubGroupLists() {
      return this.$store.state.hr.employeePositionListsSubDropdown
    },
    payGradeLists() {
      return this.$store.state.hr.payGradeList
    },
    employeeDropdownList() {
      return this.$store.state.hr.employeeDropdownList
    },
    workShifts() {
      return this.$store.state.hr.workShiftList
    },
    accountMasterList() {
      return this.$store.state.accountMaster.accountMasterLists
    }
  },
  mounted() {
    this.employeeGroupList()
    this.employeePositionList()
    this.payGradeList()
    this.findWorkShift()
    this.findPayHeads()
    this.employeeDropdownLists()
    this.employeePositionSubGroupList()
    this.accountList()
  },
  methods: {
    async findPayHeads() {
      await this.$store.dispatch('loadHrPayHeadList')
    },
    async employeeDropdownLists() {
      await this.$store.dispatch('loadEmployeeDropdownList')
    },
    async addEmployee() {
      if (this.employeeName === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Employee Name cannot be empty!', life: 3000})
        return
      }
      if (this.employeeGroupId === null) {
        // this.employeeGroupId == null
        this.employeeGrpId = 0
      } else {
        this.employeeGrpId = this.employeeGroupId.id
      }
      if (this.supervisor1 === null) {
        // this.employeeGroupId == null
        this.supervisor1Id = 0
      } else {
        this.supervisor1Id = this.supervisor1.id
      }
      if (this.supervisor2 === null) {
        // this.employeeGroupId == null
        this.supervisor2Id = 0
      } else {
        this.supervisor2Id = this.supervisor2.id
      }
      if (this.employeePositionId === null) {
        // this.employeePositionId == null
        this.employeePosId = 0
      } else {
        this.employeePosId = this.employeePositionId.id
      }
      if (this.subGroupChildId === null) {
        // this.employeePositionId == null
        this.subGroupChId = 0
      } else {
        this.subGroupChId = this.employeePositionId.id
      }
      let payheadEditinList = []
      if (this.editing) {
        payheadEditinList = this.payheadEditingList
      } else {
        payheadEditinList = this.payHeadList
      }
      if (this.accountMasterId !== null) {
        this.accountCrId = this.accountMasterId.id
      } else {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Please Select Cr Account Ledger!', life: 3000})
        return
      }
      let employee = {
        id: this.id,
        employeeName: this.employeeName,
        dateOfJoin: this.dateOfJoin,
        inActiveDate: this.inActiveDate,
        contactNumber: this.contactNumber,
        panNo: this.panNo,
        cifNo: this.cifNo,
        pfNumber: this.pfNumber,
        address: this.address,
        salaryStatus: this.salaryStatus,
        employeeId: this.employeeId,
        groupId: this.employeeGrpId,
        positionId: this.employeePosId,
        subGroupChildId: this.subGroupChId,
        hrPayHeadsDTOList: payheadEditinList,
        supervisorId1: this.supervisor1Id,
        supervisorId2: this.supervisor2Id,
        accountId: this.accountCrId,
        bankAccountNumber: this.bankAccountNumber
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createEmployee', employee)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateEmployee', employee)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    async employeeGroupList() {
      await this.$store.dispatch('loadHrMasterForDropdownList', 'EmployeeGroup')
    },
    async employeePositionList() {
      await this.$store.dispatch('loadHrMasterForDropdownList', 'EmployeePosition')
    },
    async employeePositionSubGroupList() {
      await this.$store.dispatch('loadHrMasterForDropdownList', 'EmployeePositionSubGroup')
    },
    async payGradeList() {
      await this.$store.dispatch('loadHrPayHeadList')
    },
    async findWorkShift() {
      await this.$store.dispatch('loadWorkShiftList')
    },
    async accountList() {
      await this.$store.dispatch('loadOfficeAccountListForDropdown')
    },
    reset() {
      this.employeeName = ''
      this.dateOfJoin = null
      this.contactNumber = ''
      this.accountId = null
      this.panNo = ''
      this.cifNo = ''
      this.pfNumber = ''
      this.address = ''
      this.salaryStatus = ''
      this.employeeId = ''
      this.employeeGrpId = ''
      this.employeePosId = ''
      this.hrPayHeadsDTOList = []
      this.editing = false
      this.displayBasic = false
      this.supervisor1 = null
      this.supervisor2 = null
      this.employeePositionId = null
      this.subGroupChildId = null
      this.accountMasterId = null
      this.bankAccountNumber = ''
      this.employeeGroupId = null
    },
    editEmployee(data) {
      this.editing = true
      this.id = data.id
      this.employeeName = data.employeeName
      this.address = data.address
      this.contactNumber = data.contactNumber
      this.panNo = data.panNo
      this.salaryStatus = data.salaryStatus
      this.dateOfJoin = data.dateOfJoin
      this.employeeId = data.employeeId
      this.payheadEditingList = data.hrPayHeadsDTOList
      this.cifNo = data.cifNo
      this.bankAccountNumber = data.bankAccountNumber
      this.pfNumber = data.pfNumber
      if (data.group !== undefined) {
        this.employeeGroupId = data.group
      }
      if (data.position !== undefined) {
        this.employeePositionId = data.position
      }
      if (data.subGroupChild !== undefined) {
        this.subGroupChildId = data.subGroupChild
      }
      if (data.supervisor1 !== undefined) {
        this.supervisor1 = data.supervisor1
      }
      if (data.supervisor2 !== undefined) {
        this.supervisor2 = data.supervisor2
      }
      if (data.account !== undefined) {
        this.accountMasterId = data.account
      }
      this.displayOnly = false
      this.openBasic()
    },
    viewEmployee(data) {
      this.displayOnly = true
      this.editing = true
      this.id = data.id
      this.employeeName = data.employeeName
      this.address = data.address
      this.contactNumber = data.contactNumber
      this.panNo = data.panNo
      this.salaryStatus = data.salaryStatus
      this.dateOfJoin = data.dateOfJoin
      this.employeeId = data.employeeId
      this.payheadEditingList = data.hrPayHeadsDTOList
      this.payheadEditingList = data.hrPayHeadsDTOList
      this.cifNo = data.cifNo
      this.bankAccountNumber = data.bankAccountNumber
      this.pfNumber = data.pfNumber
      if (data.group !== undefined) {
        this.employeeGroupId = data.group
      }
      if (data.position !== undefined) {
        this.employeePositionId = data.position
      }
      if (data.subGroupChild !== undefined) {
        this.subGroupChildId = data.subGroupChild
      }
      if (data.supervisor1 !== undefined) {
        this.supervisor1 = data.supervisor1
      }
      if (data.supervisor2 !== undefined) {
        this.supervisor2 = data.supervisor2
      }
      if (data.account !== undefined) {
        this.accountMasterId = data.account
      }
      this.openBasic()
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    cancel() {
      this.reset()
    },
    closeDialog() {
      this.reset()
      this.displayOnly = false
    },
    addToPayHeadList(data) {
      let payHead = {
        id: data.id,
        amount: data.amount
      }
      this.hrPayHeadsDTOList.push({...payHead})
    },
    checkNepaliDateOrEnglish() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        if (this.editing === false) {
          this.setNepaliDate()
        }
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.dateOfJoin = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.dateOfJoin = new Date().toISOString().slice(0, 10)
    },
    nepaliDate() {
      $('#dateOfJoin').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.dateOfJoin = $('#dateOfJoin').val()
        }
      })
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    RadioButton,
    InputMask,
    employeeGroup,
    Dropdown,
    employeePosition,
    employeeList,
    DataTable,
    Column,
    InputNumber
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// employee.vue?cc2d90f0